import { useGetContractById } from "@/services/queries/useContratos";
import { PersonProfile } from "@/types/contract";
import { useParams } from "wouter";

export function useContratoDetails() {
  const params = useParams()
  const contractId = params.id ? parseInt(params.id) : 0

  const { data: contract, isLoading, error } = useGetContractById(contractId)

  function formateDateUtcToLocal(dateString: string) {
    const datePart = dateString.split('T')[0];
    const [year, month, day] = datePart.split('-');
    return `${day}/${month}/${year}`;
  }

  const personProfile: PersonProfile = {
    id: contract?.data.staffUser?.person?.id?.toString() || "0",
    name: contract?.data.staffUser?.person?.name || "Sem nome",
    avatar: "",
    role: contract?.data.staffUser?.person?.role || "Sem função",
    company: "N/A", // Not in backend
    biography: contract?.data.contractDescription || "",
    phone: "N/A", // Not in backend
    email: contract?.data.staffUser?.login || "N/A",
    location: "N/A", // Not in backend
    socialMedia: {
      instagram: "",
      linkedin: "",
      email: contract?.data.staffUser?.login || ""
    },
    skills: ""
  }

  return {
    contractId,
    formateDateUtcToLocal,
    contract,
    isLoading,
    error,
    personProfile
  };
}